import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getAllEvents } from '../../features/event/eventSlice';
import { Typography, Box, CircularProgress } from '@mui/material';

import moment from 'moment';
import { useTitle } from '../../hooks/titleProvider';
import EventsTable from '../ui/table/eventTable';
import AddEditEventDialog from './addEditEventDialog';

const EventArchive = () => {
  const dispatch = useDispatch();
  const events = useSelector((state) => state.event.events);
  const loadingEvents = useSelector((state) => state.event.loading);
  const [sortedEvents, setSortedEvents] = useState([]);

  const [openEdit, setOpenEdit] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState(null);

  const { setTitle } = useTitle();
  setTitle('Events');

  useEffect(() => {
    dispatch(getAllEvents());
  }, [dispatch]);

  useEffect(() => {
    if (events.length > 0) {
      const now = moment();
      const filteredEvents = [...events].filter((event) => {
        return moment(event.startDate).isBefore(now);
      });

      const _sortedEvents = filteredEvents.sort((a, b) => {
        return moment(a.startDate).isBefore(moment(b.startDate)) ? 1 : -1;
      });

      setSortedEvents(_sortedEvents);
    }
  }, [events]);

  const handleEditOpen = async (event) => {
    setSelectedEvent(event);
    setOpenEdit(true);
  };

  const handleEditClose = async () => {
    setSelectedEvent(null);
    setOpenEdit(false);
  };

  const handleDeleteClose = async () => {
    setOpenDelete(false);
  };

  const handleDeleteOpen = async (event) => {
    setSelectedEvent(event);
    setOpenDelete(true);
  };

  return (
    <>
      <Box
        display={'flex'}
        flexDirection={'row'}
        justifyContent={'space-between'}
        alignItems={'center'}
        mb={2}>
        <Typography variant="h5" component="h1">
          Past Events
        </Typography>
      </Box>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column'
        }}>
        {!loadingEvents ? (
          <EventsTable
            events={sortedEvents}
            onEdit={(event) => handleEditOpen(event)}
            onDelete={(event) => handleDeleteOpen(event)}
          />
        ) : (
          <Box
            display="flex"
            flexDirection={'row'}
            justifyContent={'center'}
            alignItems={'center'}
            m={5}>
            <CircularProgress />
          </Box>
        )}
      </Box>

      {selectedEvent ? (
        <AddEditEventDialog
          open={openEdit}
          onClose={() => handleEditClose()}
          event={selectedEvent}
        />
      ) : (
        <AddEditEventDialog open={openEdit} onClose={() => handleEditClose()} />
      )}
    </>
  );
};

export default EventArchive;
